import React from 'react';
import { head } from 'ramda';
import { Icon } from '../../../icon';
import { FileInfo } from './file-info';
import { ActionButtons } from './action-buttons';
import { StyledFileCard } from './styled';
import { formatErrorMessage } from '../../utils';
export const FileCard = ({ file, maxSize, hasError, onAttach, onRemoveFile, onAbort, onPreview, onDownload, className, disabled }) => {
    var _a;
    const errorMessage = file.errors
        ? formatErrorMessage((_a = head(file.errors)) === null || _a === void 0 ? void 0 : _a.code, maxSize)
        : undefined;
    return (React.createElement(StyledFileCard, { className: className },
        React.createElement(Icon, { name: "file", size: "xlarge" }),
        React.createElement(FileInfo, { fileName: file.name, fileSizeByte: file === null || file === void 0 ? void 0 : file.size, hasError: hasError, errorMessage: errorMessage, fileState: file.uploadStatus }),
        React.createElement(ActionButtons, { file: file, onAttach: onAttach, onRemoveFile: onRemoveFile, onAbort: onAbort, onPreview: onPreview, onDownload: onDownload, disabled: disabled })));
};
